/**
 * @module utils/root
 */

/**
 * @typedef {{}} Object
 * @typedef {{}} Prototype
 */

import prototypes from './prototypes.js'

/**
 * Returns the non-null top ancestor prototype of an object() instance or the instance itself
 * @param {Object} object
 * @return {Object|Prototype}
 */
export default object => [...prototypes(object)].at(-2) ?? object
